// Icons
import {
	FileLineChart,
	LayoutList,
	FileText,
	MessageSquareText,
	Building2,
	FileSpreadsheet,
	FilePenLine,
} from "lucide-react";

const sideBarMenus = [
	{
		title: "ພາບລວມ",
		navItems: [
			{
				name: "ລາຍງານສະພາບລວມ",
				icon: FileLineChart,
				link: "/report/overview",
			},
		],
	},
	{
		title: "ເອກະສານລາຍງານ",
		navItems: [
			{
				name: "ແຜນດຳເນີນງານ",
				icon: LayoutList,
				link: "/report/action-plan",
			},
			{
				name: "ແຜນມອບພັນທະໃຫ້ລັດ",
				icon: LayoutList,
				link: "/report/tax-obligations",
			},
			{
				name: "ລາຍງານການເງິນລັດວິສາຫະກິດ",
				icon: FileLineChart,
				link: "/report/finance",
			},

			{
				name: "ລາຍງານມອບພັນທະໃຫ້ລັດ",
				icon: FileText,
				link: "/report/obligation",
			},
			{
				name: "ລາຍງານການປະເມີນທີ່ບໍ່ແມ່ນການເງິນ",
				icon: FileText,
				link: "/report/non-financial-assessment",
			},
			{
				name: "ລາຍງານການປະເມີນສະພາບໍລິຫານ",
				icon: FilePenLine,
				link: "/report/board-of-directors",
			},
			{
				name: "ລາຍງານການປະເມີນອຳນວຍການ",
				icon: FileSpreadsheet,
				link: "/report/director",
			},
		],
	},
	{
		title: "ກົດໝາຍ ແລະ ນິຕິກຳ",
		navItems: [
			{
				name: "ລາຍການກົດໝາຍ ແລະ ນິຕິກຳ",
				icon: FileText,
				link: "/law",
			},
		],
	},

	{
		title: "ການສື່ສານ",
		navItems: [
			{
				name: "ຂໍ້ຄວາມສົນທະນາ",
				icon: MessageSquareText,
				link: "/chat",
			},
			// {
			// 	name: "ຂ່າວສານ",
			// 	icon: Newspaper,
			// 	link: "/news",
			// },
		],
	},
	{
		title: "ບັນຊີບໍລິສັດ",
		navItems: [
			{
				name: "ຈັດການຂໍ້ມູນບໍລິສັດ",
				icon: Building2,
				link: "/account-management/soe/general",
			},
			// {
			// 	name: "ຈັດການບັນຊີເຂົ້າສູ່ລະບົບ",
			// 	icon: SquareUserRound,
			// 	link: "/account-management/sub-account",
			// },
		],
	},
];

const soeInformationMenus = [
	{
		name: "ຂໍ້ມູນທົ່ວໄປ",
		href: "/account-management/soe/general",
	},
	{
		name: "ບໍລິສັດຍ່ອຍ / ໃນເຄືອ",
		href: "/account-management/soe/joint-venture",
	},
	{
		name: "ຄະນະອຳນວຍການ",
		href: "/account-management/soe/director",
	},
	{
		name: "ການຈັດຕັ້ງຂັ້ນພະແນກ",
		href: "/account-management/soe/department",
	},
	{
		name: "ຄະນະສະພາບໍລິຫານ",
		href: "/account-management/soe/board-of-directors",
	},
	{
		name: "ຂໍ້ມູນທີ່ດິນ",
		href: "/account-management/soe/land",
	},
	// {
	// 	name: "ຂໍ້ມູນກອງເລຂາ",
	// 	href: "/account-management/soe/secretariat",
	// },
	{
		name: "ຂໍ້ມູນບັນຊີເຂົ້າລະບົບ",
		href: "/account-management/soe/account",
	},
];
function getFinanceSideBarMenusconpany() {
	return [
		{
			name: "ລາຍງານຖານະການເງິນ - ຊັບສິນ",
			href: "/report/finance/company/finance-property",
		},
		{
			name: "ລາຍງານຖານະການເງິນ - ໜີ້ສິນ",
			href: "/report/finance/company/finance-debt",
		},
		{
			name: "ລາຍງານກະແສເງິນສົດ - ຈັດຕາມແບບວິທີທາງກົງ",
			href: "/report/finance/company/cash-flow-direct-method",
		},
		{
			name: "ລາຍງານກະແສເງິນສົດ - ຈັດຕາມແບບວິທີທາງອ້ອມ",
			href: "/report/finance/company/cash-flow-indirect-method",
		},
		{
			name: "ລາຍງານຜົນການດຳເນີນງານ",
			href: "/report/finance/company/result",
		},
		{
			name: "ລາຍງານສ່ວນປ່ຽນແປງທຶນເຈົ້າຂອງ",
			href: "/report/finance/company/owner-equity",
		},
		{
			name: "ລາຍງານຊັບສິນຄົງທີ່",
			href: "/report/finance/company/fix-assets",
		},
		{
			name: "ບັນດາຕົວຊີ້ວັດທີ່ຈະນຳໃຊ້ຂໍ້ມູນ",
			href: "/report/finance/company/indicators",
		},
	];
}
function getFinanceSideBarMenusbank() {
	return [
		{
			name: "ລາຍງານຖານະການເງິນ - ຊັບສິນ",
			href: "/report/finance/bank/finance-property",
		},
		{
			name: "ລາຍງານຖານະການເງິນ - ໜີ້ສິນ",
			href: "/report/finance/bank/finance-debt",
		},
		{
			name: "ລາຍງານກະແສເງິນສົດ",
			href: "/report/finance/bank/cash-flow",
		},

		{
			name: "ລາຍງານຜົນໄດ້ຮັບ",
			href: "/report/finance/bank/result",
		},
		{
			name: "ລາຍງານສ່ວນປ່ຽນແປງທຶນເຈົ້າຂອງ",
			href: "/report/finance/bank/owner-equity",
		},
	];
}
function postFinanceSideBarMenusbank() {
	return [
		{
			name: "ລາຍງານຖານະການເງິນ - ຊັບສິນ",
			href: "/report/finance/bank/add/finance-property",
		},
		{
			name: "ລາຍງານຖານະການເງິນ - ໜີ້ສິນ",
			href: "/report/finance/bank/add/finance-debt",
		},
		{
			name: "ລາຍງານກະແສເງິນສົດ",
			href: "/report/finance/bank/add/cash-flow",
		},

		{
			name: "ລາຍງານຜົນໄດ້ຮັບ",
			href: "/report/finance/bank/add/result",
		},
		{
			name: "ລາຍງານສ່ວນປ່ຽນແປງທຶນເຈົ້າຂອງ",
			href: "/report/finance/bank/add/owner-equity",
		},
	];
}

const siteConfig = {
	sideBarMenus,
	soeInformationMenus,
	getFinanceSideBarMenusconpany,
	getFinanceSideBarMenusbank,
	postFinanceSideBarMenusbank,
};

export default siteConfig;
